import React from 'react'
import Layout from '../../layout/Layout'
import '../blog/blog.css'
const Blog = () => {
  return (
<Layout>
    <section>
      Blog
    {/* <div className='wrapper-1'>
    <div className="content-1">
  <div className='content-flex'>
  <div className="heart"></div>
  <p className='plant-name'>  plant for tree</p>
  </div>
    </div>
 </div> */}
    </section>
</Layout>
  )
}

export default Blog